import React from "react";

import { Nav, Tab } from "react-bootstrap";
import Chart from "../../../Assets/Images/shopping-cart-icon.png";
import AuctionsImg from "../../../Assets/Images/Souvenir/Icons/auction.png";

import AuctionMap from "./AuctionMap";
import MarketMap from "./MarketMap";
import "./TabMarket.css";
import {useI18n} from "../../../i18n";
const TabMarket = () => {
  const { t } = useI18n();
  return (
    <div>
      <div className="col-md-12   AuctionR  ">
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="d-flex my-3 ">
            <Nav
              variant="pills"
              className="flex-column card p-3 card-bg1 border-0"
            >
              <div className="d-flex  ">
                <div className="col-md-6  ">
                  <Nav.Link
                    eventKey="first"
                    className="btn newMarketTab me-2 fw-bold "
                  >
                    <span>
                      {" "}
                      <img src={Chart} className="img-fluid-Tab mx-2 " alt="" />
                    </span>
                    <span> {t('Marketplace_Text')}</span>
                  </Nav.Link>
                </div>

                <div className=" col-md-6 ">
                  <Nav.Link
                    eventKey="second"
                    className="btn newMarketTab ms-2 fw-bold"
                  >
                    <span>
                      {" "}
                      <img
                        src={AuctionsImg}
                        className="img-fluid-Tab mx-2"
                        alt=""
                      />
                    </span>
                    <span>{t('Auctions_Text')}</span>
                  </Nav.Link>
                </div>
              </div>
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="first">
              <MarketMap />
            </Tab.Pane>

            <Tab.Pane eventKey="second">
              <AuctionMap />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default TabMarket;
